import { __rest, __assign } from '../node_modules/tslib/tslib.es6.esm.js';
import React__default, { forwardRef } from 'react';
import classNames from 'classnames';
import { checkValidLabel } from '../utils/accessibility.esm.js';
import NvFormControl from '../NvFormControl/NvFormControl.esm.js';

var NvTextArea = forwardRef(function (_a, ref) {
    var classes = _a.classes, helperText = _a.helperText, error = _a.error, _b = _a.id, id = _b === void 0 ? 'nv-text-area' : _b, hideLabel = _a.hideLabel, label = _a.label, legendText = _a.legendText, hasError = _a.hasError, className = _a.className, htmlForId = _a.htmlForId, children = _a.children, hideError = _a.hideError, componentLabel = _a.componentLabel, isDisabled = _a.isDisabled, readOnly = _a.readOnly, required = _a.required, tooltipText = _a.tooltipText, disabled = _a.disabled, props = __rest(_a, ["classes", "helperText", "error", "id", "hideLabel", "label", "legendText", "hasError", "className", "htmlForId", "children", "hideError", "componentLabel", "isDisabled", "readOnly", "required", "tooltipText", "disabled"]);
    checkValidLabel(label, htmlForId || id);
    var formControlProps = {
        children: children,
        className: classNames(classes === null || classes === void 0 ? void 0 : classes.root, className),
        componentLabel: componentLabel,
        hasError: hasError || error,
        hideError: hideError,
        hideLabel: hideLabel,
        htmlForId: htmlForId || id,
        isDisabled: isDisabled || disabled,
        label: label,
        legendText: legendText || helperText,
        readOnly: readOnly,
        required: required,
        tooltipText: tooltipText,
    };
    return (React__default.createElement(NvFormControl, __assign({}, formControlProps, { ref: ref }),
        React__default.createElement("textarea", __assign({ "aria-disabled": formControlProps.isDisabled, "aria-label": label, className: classNames('nv-textarea-input', classes === null || classes === void 0 ? void 0 : classes.field), id: formControlProps.htmlForId, readOnly: readOnly, required: required }, props))));
});
NvTextArea.displayName = 'NvTextArea';

export { NvTextArea as default };
//# sourceMappingURL=NvTextArea.esm.js.map
